export default {"src":"/_next/static/media/L.c71000a1.svg","height":18,"width":18};